import React, { lazy, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "../pages/home/Home";
import UserType from "../Hook/userType/UserType";
import { NotificationBell } from "../contexts/Notifications";

const Admin = lazy(() => import("../pages/admin/Admin"));
const AddBrand = lazy(() => import("../components/admin/AddBrand"));
const AddDiscount = lazy(() => import("../components/admin/AddDiscount"));
const Login = lazy(() => import("../pages/login/Login"));
const AllOrder = lazy(() => import("../components/admin/AllOrder"));
const Order = lazy(() => import("../pages/order/Order"));
const AddColore = lazy(() => import("../components/admin/AddColor"));
const Profile = lazy(() => import("../pages/profile/Profile"));
const AddProduct = lazy(() => import("../components/admin/addProduct"));
const CategoryManager = lazy(() => import("../components/admin/addCategory"));
const UpdateProduct = lazy(() => import("../components/admin/UpdateProduct"));
const SalesDashboard = lazy(() => import("../components/admin/SalesDashboard"));
const Coupons = lazy(() => import("../components/admin/Coupons"));
const Categories = lazy(() => import("../components/admin/Categories"));
const WhatsAppSettings = lazy(() => import("../components/admin/WhatsAppSettings"));
const ImportProducts = lazy(() => import("../components/admin/ImportProducts"));
const UserChat = lazy(() => import("../pages/chat/UserChat"));
const AdminChatNew = lazy(() => import("../pages/chat/AdminChatNew"));
const PaymentCallback = lazy(() => import("../pages/payment/PaymentCallback"));
const Products = lazy(() => import("../pages/Products"));
const DetailedProduct = lazy(() => import("../pages/DetailedProduct"));
const Cart = lazy(() => import("../pages/cart/Cart"));
const MyOrders = lazy(() => import("../pages/myorder/MyOrders"));

const ProtectedRoute = ({ children }) => {
  const [userData] = UserType();
  if (!userData) return <Navigate to="/login" />;
  return children;
};

const Router = () => {
  return (
    <div>
      <Suspense fallback={<div className="route-fallback" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:product_id" element={<DetailedProduct />} />
          <Route path="/categories/:id" element={<Products />} />
          <Route path="/offers" element={<Products offers={true} />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/order/:id" element={<Order />} />
          <Route path="/orders" element={<MyOrders />} />
          <Route path="/chat" element={<UserChat />} />
          <Route path="/payment/callback" element={<PaymentCallback />} />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route path="/admin/*" element={<Admin />}>
            <Route path="add_product" element={<AddProduct />} />
            <Route path="import_products" element={<ImportProducts />} />
            <Route path="categories" element={<Categories />} />
            <Route path="coupons" element={<Coupons />} />
            <Route path="notifications" element={<NotificationBell />} />
            <Route path="sales" element={<SalesDashboard />} />
            <Route path="update_product/:id" element={<UpdateProduct />} />
            <Route path="add_category" element={<CategoryManager />} />
            <Route path="add_brand" element={<AddBrand />} />
            <Route path="add_color" element={<AddColore />} />
            <Route path="all_order" element={<AllOrder />} />
            <Route path="whatsapp" element={<WhatsAppSettings />} />
            <Route path="add_discount" element={<AddDiscount />} />
            <Route path="chat" element={<AdminChatNew />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
};

export default Router;
